export const settings = {
  title: 'Cài đặt bán hàng',
  subtitle: 'Bật/tắt các tính năng theo dự án. Thay đổi có hiệu lực ngay sau khi lưu.',
  searchPlaceholder: 'Tìm kiếm thiết lập',
  sidebarSection: 'Quản lý',
  sidebarNghiepVu: 'Nghiệp vụ',
  sidebarCuaHang: 'Cửa hàng',
  sidebarTichHop: 'Tích hợp',
  sidebarCucBo: 'Cục bộ',
  loadError: 'Không tải được cài đặt bán hàng.',
  noData: 'Không có cài đặt nào trong nhóm này.',
  noSearchResult: 'Không tìm thấy thiết lập phù hợp.',
  readOnlyHint: 'Bạn chỉ có quyền xem cài đặt.',
  configureDetail: 'Cấu hình chi tiết',
  configureShort: 'Cấu hình',
  detailSectionTitle: 'Tuỳ chọn chi tiết',
  detailModalTitles: {
    BAN_HANG_HET_TON_KHO: 'Cho phép giao dịch khi hết tồn kho',
    GIAO_DICH_HANG_NGUNG_KINH_DOANH: 'Cho phép giao dịch hàng ngừng kinh doanh',
    TU_DONG_TAO_PHIEU_XUAT: 'Tự động tạo phiếu xuất kho',
    TU_DONG_TAO_PHIEU_NHAP: 'Tự động tạo phiếu nhập kho',
    KHONG_THAY_DOI_THOI_GIAN: 'Không đổi thời gian giao dịch',
    DAT_HANG: 'Cấu hình đặt hàng',
  },
  helpMore: 'Xem chú thích',
  tabSummary: 'Đang bật {active}/{total}',
  statusOn: 'Đang bật',
  statusOff: 'Đang tắt',
  saving: 'Đang xử lý...',
  savedSuccess: 'Đã lưu cài đặt.',
  updateError: 'Cập nhật thất bại.',
  saoChep: {
    button: 'Sao chép sang dự án khác',
    title: 'Sao chép cài đặt giao dịch',
    description:
      'Toàn bộ cài đặt giao dịch của dự án hiện tại (kể cả tự động chốt công nợ) sẽ ghi đè lên các dự án được chọn.',
    selectAll: 'Chọn tất cả',
    clear: 'Bỏ chọn',
    empty: 'Bạn không thuộc dự án nào khác.',
    action: 'Sao chép ({count})',
    needSelected: 'Chọn ít nhất một dự án.',
    success: 'Đã sao chép cài đặt sang {count} dự án.',
    loadError: 'Không tải được danh sách dự án.',
    saveError: 'Sao chép cài đặt thất bại.',
  },
  tichHopVanChuyen: {
    title: 'Kết nối API',
    description:
      'Cấu hình kết nối GHTK, Viettel Post, Shopee Express (SPX) để tạo vận đơn và nhận webhook. Bật kết nối để chọn hãng khi lập hóa đơn giao hàng.',
    configure: 'Cấu hình',
    empty: 'Chưa cấu hình — bấm Cấu hình để nhập token của hãng.',
    connected: 'Đang kết nối',
    inactive: 'Chưa kích hoạt',
    production: 'Production',
    sandbox: 'Sandbox',
    checkConnection: 'Kiểm tra',
    edit: 'Sửa',
    webhook: 'Webhook',
    lastError: 'Lỗi gần nhất',
    notConfigured: 'Chưa cấu hình',
    turnOn: 'Bật kết nối — hãng sẽ chọn được khi lập hóa đơn giao hàng',
    turnOff: 'Tắt kết nối — ẩn hãng khỏi hóa đơn giao hàng',
    environment: 'Môi trường',
    token: 'Token',
    lastCheck: 'Kiểm tra gần nhất',
    copyWebhook: 'Copy URL webhook để đăng ký với hãng',
    connectionInfo: 'Thông tin kết nối',
    pickupAddress: 'Địa chỉ lấy hàng mặc định',
  },
  tabs: {
    hangHoa: 'Hàng hóa',
    doiTac: 'Đối tác',
    giaoDich: 'Giao dịch',
    giaoHang: 'Giao hàng',
    thongBaoZalo: 'Thông báo Zalo',
    logo: 'Logo',
    mauIn: 'Mẫu in',
    quyTacMa: 'Quy tắc mã',
    diaChiLayHang: 'Địa chỉ lấy hàng',
    formatSo: 'Format số',
    caiDatBang: 'Cài đặt bảng',
    thongBao: 'Thông báo',
    phamViXemDon: 'Phạm vi xem đơn',
  },
  phamViXemDon: {
    title: 'Phạm vi xem đơn',
    description:
      'Cấu hình NV được xem đơn/hóa đơn của NV khác, và mở hóa đơn theo từng khách hàng cho NV khác.',
    loadError: 'Không tải được phạm vi xem đơn.',
    loadOptsError: 'Không tải được danh sách nhân viên / khách hàng.',
    save: 'Lưu',
    savedSuccess: 'Đã lưu phạm vi xem đơn.',
    saveError: 'Lưu phạm vi xem đơn thất bại.',
    sameUserError: 'Người cho phép và người được xem phải khác nhau.',
    pickUser: 'Chọn nhân viên',
    pickUsers: 'Chọn nhân viên được xem',
    pickCustomers: 'Chọn khách hàng',
    nguoiBan: {
      title: 'Xem đơn theo người bán',
      hint: 'Chọn NV A, rồi chọn các NV mà A được xem đơn đặt hàng / hóa đơn.',
      viewer: 'Nhân viên được cấu hình (A)',
      targets: 'Được xem đơn của các NV',
    },
    khachHang: {
      title: 'Mở hóa đơn theo khách hàng',
      hint: 'NV A mở khách hàng 1, 2 cho NV B xem hóa đơn — KH chưa mở thì B không xem được.',
      nguoiChoPhep: 'Nhân viên mở quyền (A)',
      viewer: 'Nhân viên được xem (B)',
      customers: 'Khách hàng được mở',
    },
  },
  cauHinhFields: {
    choPhepDatHangHetTonKho: 'Cho phép đặt hàng khi hết tồn kho',
    banHangKhiDaDatHang: 'Bán hàng, Chuyển hàng khi sản phẩm đã được Đặt hàng',
    choPhepChuyenChiNhanh: 'Cho phép chuyển đơn đặt hàng sang chi nhánh khác',
    banHang: 'Bán hàng',
    datHang: 'Đặt hàng',
    hoaDon: 'Hóa đơn',
    traHang: 'Trả hàng',
    datHangNhap: 'Đặt hàng nhập',
    nhapHang: 'Nhập hàng',
    traHangNhap: 'Trả hàng nhập',
    chuyenHang: 'Chuyển hàng',
    phieuNhanHang: 'Phiếu nhận hàng',
    yeuCauSuaChua: 'Yêu cầu sửa chữa',
    yeuCauXuatHoaDon: 'Yêu cầu xuất hóa đơn',
    nhapKho: 'Nhập kho',
    xuatKho: 'Xuất kho',
    phieuThu: 'Phiếu thu',
    phieuChi: 'Phiếu chi',
    kiemKe: 'Kiểm kê',
    xuatHuy: 'Xuất hủy',
    soQuy: 'Sổ quỹ',
    kiemKho: 'Kiểm kho',
    sanXuat: 'Sản xuất',
  },
  thoiGianGiaoDich: {
    khongChoPhep: 'Không cho phép',
    choPhep: 'Cho phép',
    gioiHan: 'Giới hạn',
    truoc: 'Trước',
    sau: 'Sau',
    ngay: 'ngày',
  },
  logoChiNhanh: {
    title: 'Logo chi nhánh',
    description: 'Mỗi chi nhánh đang hoạt động một logo. Dùng khi in hóa đơn, phiếu và mẫu in.',
    empty: 'Không có chi nhánh đang hoạt động trong dự án.',
    choose: 'Chọn logo',
    paste: 'Dán logo',
    pasteHint: 'Kéo thả ảnh vào khung, dán từ clipboard hoặc link http(s).',
    dragDrop: 'Kéo thả ảnh vào đây',
    remove: 'Xóa logo',
    emptySlot: 'Chưa có logo — chọn hoặc kéo thả ảnh',
    attachedSummary: 'Đã gắn logo {attached}/{total} chi nhánh',
    loadError: 'Không tải được logo chi nhánh.',
    saveError: 'Không lưu được logo chi nhánh.',
    applyToAll: 'Áp dụng cho tất cả',
    applyToSelected: 'Áp dụng sang đã chọn',
    setSameForAll: 'Set giống nhau cho tất cả',
    setSameMenuHint: 'Chọn chi nhánh nguồn (có logo)',
    selectBranch: 'Chọn',
    selectedCount: 'Đã chọn {count}',
    selectAll: 'Chọn tất cả',
    clearSelect: 'Bỏ chọn',
    applyConfirmTitle: 'Xác nhận áp dụng logo',
    applyConfirmAction: 'Áp dụng',
    applyConfirmAll: 'Gắn cùng logo của “{source}” cho tất cả {count} chi nhánh?',
    applyConfirmSelected: 'Gắn logo của “{source}” cho {count} chi nhánh đã chọn?',
    applySuccess: 'Đã cập nhật logo cho {count} chi nhánh.',
    applyPartial: 'Cập nhật {ok}/{total} chi nhánh. Một số chi nhánh lỗi.',
    applyNeedSource: 'Cần một chi nhánh đã có logo để sao chép.',
    applyNeedSelected: 'Chọn ít nhất một chi nhánh đích.',
    applying: 'Đang áp dụng…',
  },
  quyTacMa: {
    title: 'Quy tắc mã',
    description: 'Tự sinh hoặc nhập tay cho từng loại mã. Lưu theo dự án.',
    summary: 'Tự sinh {auto}/{total} loại mã',
    loadError: 'Không tải được quy tắc mã.',
    saveError: 'Không lưu được quy tắc mã.',
    groups: {
      hangHoa: 'Hàng hóa',
      doiTac: 'Đối tác',
      giaoDich: 'Giao dịch',
    },
    items: {
      hangHoa: 'Mã hàng hóa',
      khachHang: 'Mã khách hàng',
      nhaCungCap: 'Mã nhà cung cấp',
      hoaDon: 'Mã hóa đơn',
      datHang: 'Mã đặt hàng',
      traHang: 'Mã trả hàng',
      phieuNhapKho: 'Mã phiếu nhập kho',
      phieuXuatKho: 'Mã phiếu xuất kho',
      chuyenHang: 'Mã chuyển hàng',
      kiemKe: 'Mã kiểm kê',
      phieuThu: 'Mã phiếu thu',
      phieuChi: 'Mã phiếu chi',
      yeuCauSuaChua: 'Mã yêu cầu sửa chữa',
      yeuCauXuatHoaDon: 'Mã yêu cầu xuất hóa đơn',
    },
    itemDesc: {
      hangHoa: 'SP + 8 số (SP00000001). Để trống thì tự sinh, có thể nhập tay.',
      khachHang: 'KH + 7 số (KH0000001). Để trống thì tự sinh, có thể nhập lại.',
      nhaCungCap: 'Mặc định hiện tại: NCC + 4 số (NCC0001).',
      hoaDon: 'Đơn thường HD0000001. Qua yêu cầu sửa chữa HDSC0000001.',
      datHang: 'DH0000001.',
      traHang: 'Theo hóa đơn THHD0000001 / THHDSC0000001. Trả nhanh TH0000001. Chuyển hoàn CHHD0000001 / CHHDSC0000001.',
      phieuNhapKho: 'NK0000001.',
      phieuXuatKho: 'XK0000001.',
      chuyenHang: 'TF0000001.',
      kiemKe: 'KK0000001.',
      phieuThu: 'THU0000001.',
      phieuChi: 'CHI0000001.',
      yeuCauSuaChua: 'YCSC0000001.',
      yeuCauXuatHoaDon: 'YCXV0000001.',
    },
    cheDoTitle: 'Cách tạo mã',
    cheDo: {
      tuSinh: 'Tự sinh',
      nhapTay: 'Nhập tay',
    },
    cheDoHint: {
      tuSinh: 'Hệ thống tự tạo mã theo quy tắc bên dưới khi để trống.',
      nhapTay: 'Người dùng phải nhập mã khi tạo mới.',
    },
    ruleTitle: 'Quy tắc tự sinh',
    prefix: 'Tiền tố',
    prefixRequired: 'Nhập tiền tố khi chọn tự sinh.',
    padLength: 'Số chữ số',
    includeNguon: 'Thêm nguồn',
    includeNguonHint: 'Chèn mã nguồn (BT, DH, HD…) vào giữa tiền tố và số.',
    nguonMau: 'Nguồn xem trước',
    includeYymm: 'Thêm tháng năm',
    includeYymmHint: 'Chèn YYMM theo ngày tạo, ví dụ 2609.',
    previewLabel: 'Ví dụ mã',
    previewManual: 'Người dùng nhập tay',
    rowAuto: 'Tự sinh · {preview}',
    rowManual: 'Nhập tay khi tạo mới',
    columns: {
      loai: 'Loại mã',
      cheDo: 'Cách tạo',
    },
  },
  numberFormatHint:
    'Lưu trên trình duyệt này (localStorage). Áp dụng cho hiển thị UI và format ô Excel. Khi xuất Excel, ô giữ số gốc; dấu nghìn/thập phân theo locale máy; số chữ số thập phân theo cấu hình đã lưu.',
  numberFormatDecimals: 'Số thập phân',
  numberFormatPreview: 'Xem trước',
  numberFormatReset: 'Khôi phục mặc định',
  numberFormatSaveSuccess: 'Đã lưu format số',
  numberFormatResetSuccess: 'Đã khôi phục format số mặc định',
  numberFormatVnd: 'Tiền VND',
  numberFormatVndHint: 'Làm tròn cố định (mặc định {default})',
  numberFormatUsd: 'Tiền USD',
  numberFormatUsdHint: 'Tối đa, bỏ 0 thừa (mặc định {default})',
  numberFormatRmb: 'Tiền RMB / CNY',
  numberFormatRmbHint: 'Tối đa, bỏ 0 thừa (mặc định {default})',
  numberFormatWeight: 'Cân nặng (kg)',
  numberFormatWeightHint: 'Tối đa, bỏ 0 thừa (mặc định {default})',
  numberFormatVolume: 'Số khối (m³)',
  numberFormatVolumeHint: 'Tối đa, bỏ 0 thừa (mặc định {default})',
  numberFormatGeneral: 'Số chung',
  numberFormatGeneralHint: 'Tối đa, bỏ 0 thừa (mặc định {default})',
  tablePrefsHint:
    'Dùng nút chọn cột trên từng card (giống toolbar bảng) để cấu hình. Có thể xuất/nhập giữa máy hoặc xóa về mặc định.',
  tablePrefsStatusSaved: 'Đã lưu tùy chỉnh',
  tablePrefsStatusDefault: 'Đang dùng mặc định',
  tablePrefsProduct: 'Hàng hóa',
  tablePrefsKhachHang: 'Khách hàng',
  tablePrefsNhaCungCap: 'Nhà cung cấp',
  tablePrefsHoaDon: 'Hóa đơn',
  tablePrefsDatHang: 'Đặt hàng',
  tablePrefsTraHang: 'Trả hàng',
  tablePrefsCongNoKh: 'Công nợ khách hàng',
  tablePrefsCongNoDon: 'Công nợ theo đơn',
  tablePrefsCongNoThanhToan: 'Công nợ thanh toán',
  tablePrefsCongNoHoanTien: 'Công nợ hoàn tiền',
  tablePrefsKiemKe: 'Kiểm kê',
  tablePrefsTaiKhoanQuy: 'Tài khoản quỹ',
  tablePrefsPhieuThu: 'Phiếu thu',
  tablePrefsPhieuChi: 'Phiếu chi',
  tablePrefsBangGiaHangHoa: 'Bảng giá hàng hóa',
  tablePrefsYeuCauXuatHoaDon: 'Yêu cầu xuất hóa đơn',
  browserPrefsResetAll: 'Xóa tất cả',
  browserPrefsReset: 'Về mặc định',
  browserPrefsPathLabel: 'Màn hình',
  browserPrefsStorageLabel: 'Key',
  browserPrefsResetOneSuccess: 'Đã xóa cấu hình — dùng mặc định',
  browserPrefsResetAllSuccess: 'Đã xóa toàn bộ cấu hình cột trên máy này',
  browserPrefsExport: 'Xuất cấu hình',
  browserPrefsImport: 'Nhập cấu hình',
  browserPrefsExportSuccess: 'Đã xuất {count} mục cấu hình',
  browserPrefsExportError: 'Xuất cấu hình thất bại',
  browserPrefsImportSuccess: 'Đã nhập {count} mục cấu hình',
  browserPrefsImportError: 'File không hợp lệ hoặc nhập thất bại',
  browserPrefsClearOrphans: 'Xóa {count} key cũ',
  browserPrefsClearOrphansSuccess: 'Đã xóa {count} key thừa',
  browserPrefsOpenScreen: 'Mở màn hình',
  browserPrefsOpenShort: 'Mở',
  browserPrefsConfigureOnList: 'Cấu hình cột trên bảng',
  browserPrefsEditJson: 'JSON',
  browserPrefsResetShort: 'Mặc định',
  browserPrefsJsonTitle: 'Sửa JSON localStorage',
  browserPrefsJsonSaveSuccess: 'Đã lưu JSON',
  browserPrefsJsonInvalid: 'JSON không hợp lệ',
  tuDongChotCongNo: {
    title: 'Tự động chốt công nợ',
    description:
      'Chốt công nợ toàn bộ khách hàng đang hoạt động. Chọn ngày máy chạy và ngày công nợ được chốt tới.',
    lapLai: 'Lặp lại',
    thangChay: 'Tháng chạy',
    ngayChay: 'Ngày chạy',
    ngayTrongThang: 'Ngày trong tháng',
    gio: 'Giờ',
    phut: 'Phút',
    ngayChot: 'Ngày chốt',
    thangChot: 'Tháng được chốt',
    thangSo: 'Tháng {n}',
    ngaySo: 'ngày {n}',
    lap: {
      hangThang: 'Mỗi tháng',
      hangNam: 'Mỗi năm',
    },
    moc: {
      dauThang: 'Đầu tháng',
      cuoiThang: 'Cuối tháng',
      ngayCuThe: 'Một ngày trong tháng',
    },
    mocChot: {
      cungNgayChay: 'Cùng ngày chạy',
      cuoiThangTruoc: 'Cuối tháng trước ngày chạy',
      cuoiNamTruoc: 'Cuối năm trước (31/12)',
      cuoiThangNamTruocChon: 'Cuối một tháng của năm trước',
      cuoiThangNamTruoc: 'cuối tháng {n} năm trước',
    },
    cum: {
      cuoiThangNam: 'cuối tháng {thang}',
      dauThangNam: 'đầu tháng {thang}',
      ngayThang: 'ngày {n} tháng {thang}',
      cuoiThangThang: 'cuối mỗi tháng',
      dauThangThang: 'đầu mỗi tháng',
      ngayMoiThang: 'ngày {n} mỗi tháng',
    },
    tomTat: '{lap}, {cum} lúc {gio}. Ngày chốt: {mocChot}.',
    lanToi: 'Lần tới: chạy {chay}, chốt công nợ đến hết ngày {chot}.',
    ngayNgan: 'Nếu tháng không có ngày này, hệ thống lấy ngày cuối tháng.',
  },
}
